// extracted by mini-css-extract-plugin
export default {"specialsContainer":"style_specialsContainer__Medy4"};